export default __webpack_public_path__ + "static/media/group-7360.d228aa29.svg";